import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ProfessionalContextType {
  selectedProfessionalId: string | null;
  setSelectedProfessionalId: (id: string | null) => void;
  isSidebarOpen: boolean;
  setIsSidebarOpen: (open: boolean) => void;
}

const ProfessionalContext = createContext<ProfessionalContextType | undefined>(undefined);

export const ProfessionalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedProfessionalId, setSelectedProfessionalId] = useState<string | null>(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Mobile-first closed

  return (
    <ProfessionalContext.Provider value={{ 
      selectedProfessionalId, 
      setSelectedProfessionalId,
      isSidebarOpen,
      setIsSidebarOpen
    }}>
      {children}
    </ProfessionalContext.Provider>
  );
};

export const useProfessional = () => {
  const context = useContext(ProfessionalContext);
  if (context === undefined) {
    throw new Error('useProfessional must be used within a ProfessionalProvider');
  }
  return context;
};
